export default (address: string) => {
  window.open(`http://maps.apple.com/?daddr=${address}&dirflg=d&t=m`);
};
